import pushClevertapEvent from 'clevertap/pushClevertapEvent';

import formatDate from 'clevertap/formatDate';
import moment from 'moment';
import { getToggleAllDayState } from 'clevertap/hourFilter';

export function reportsTransactionsStart({ outletIds, startDate, endDate }) {
  pushClevertapEvent('Report Transactions Start', {
    'Current Selected Outlet': outletIds,
    'Toggle All Day': getToggleAllDayState(endDate),
    'Current Time Filter Start': formatDate(startDate),
    'Current Time Filter End': formatDate(endDate),
  });
}

export function reportsTransactionsExport({ outletIds, startDate, endDate }) {
  pushClevertapEvent('Report Transactions Export', {
    'Current Selected Outlet': outletIds,
    'Toggle All Day': getToggleAllDayState(endDate),
    'Current Time Filter Start': formatDate(startDate),
    'Current Time Filter End': formatDate(endDate),
  });
}

export function reportsTransactionsSearchBarInit() {
  pushClevertapEvent('Report Transactions Search Bar Init');
}

export function reportsTransactionsSelect({ transactionDetail }) {
  pushClevertapEvent('Report Transactions Select', {
    'Current Selected Outlet': transactionDetail.outlet_ids,
    'Toggle All Day': getToggleAllDayState(transactionDetail.end_date),
    'Current Time Filter Start': formatDate(transactionDetail.start_date),
    'Current Time Filter End': formatDate(transactionDetail.end_date),
    'Transaction Date': moment(transactionDetail.created_at).format(
      'YYYY-MM-DD'
    ),
    'Transaction Time': moment(transactionDetail.created_at).format('hh:mm:ss'),
    'Receipt Number': transactionDetail.payment_no,
    'Served By': transactionDetail.served_by,
    'Collected By': transactionDetail.collected_by,
    Total: transactionDetail.total_collected - transactionDetail.total_refund,
    'Payment Method': transactionDetail.payment_type,
    'Payment Amount': transactionDetail.payment_amount,
    Change: transactionDetail.change,
    'Payment Note': transactionDetail.payment_note,
  });
}

export function reportsTransactionsResendReceipt() {
  pushClevertapEvent('Report Transactions Resend Receipt');
}

export function reportsTransactionRefund({
  amount,
  isFullRefund,
  outletIds,
  startDate,
  endDate,
}) {
  pushClevertapEvent('Report Transactions Refund', {
    Amount: amount,
    'Is Full Refund': isFullRefund,
    'Current Selected Outlet': outletIds,
    'Toggle All Day': getToggleAllDayState(endDate),
    'Current Time Filter Start': formatDate(startDate),
    'Current Time Filter End': formatDate(endDate),
  });
}

export function reportsTransactionsExportByItem({
  outletIds,
  startDate,
  endDate,
}) {
  pushClevertapEvent('Report Transactions Item Details', {
    'Current Selected Outlet': outletIds,
    'Toggle All Day': getToggleAllDayState(endDate),
    'Current Time Filter Start': formatDate(startDate),
    'Current Time Filter End': formatDate(endDate),
  });
}
